import React from 'react';
import LoadingSpinner from './LoadingSpinner';

const PageLoader = ({ className = '' }) => (
  <div className={className} aria-busy="true">
    <LoadingSpinner />
  </div>
);

export default PageLoader;
